<template>
  <v-dialog :model-value="true" max-width="520" @update:model-value="onClose">
    <v-card data-testid="live-demo-export-dialog">
      <v-card-title class="text-h6">{{ $t('live_demo.export_dialog_title') }}</v-card-title>
      <v-card-text data-testid="live-demo-export-message">
        {{ message || $t('live_demo.export_required') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="text" @click="onClose">{{ $t('live_demo.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LiveDemoExportDialog',
  props: {
    message: { type: String, default: '' },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
